import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublishService {
  private subjects: Subject<any>[] = [];

  publish(eventName: string) {
    // ensure a subject for the event name exists
    this.subjects[eventName] = this.subjects[eventName] || new Subject<any>();

    // publish event
    this.subjects[eventName].next();
  }

  on(eventName: string): Observable<any> {
    // ensure a subject for the event name exists
    this.subjects[eventName] = this.subjects[eventName] || new Subject<any>();

    // return observable
    return this.subjects[eventName].asObservable();
  }
}
